import axios from 'axios'
import moment from 'moment'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'
import config from '../../../config'

export async function postVehicleInTimeIntervalPerHour(condition = {}) { // 取得起訖時間內，景區時間單位內的車流
  let response = {}

  if(Utils.isEmptyObject(condition) || Utils.isEmptyObject(condition.sttime) || Utils.isEmptyObject(condition.endtime) || 
      Utils.isEmptyObject(condition.interval) || !Array.isArray(condition.areas)) {
    console.log('iisi postVehicleInTimeIntervalPerHour: condition error')
    return {}   
  }

  try {
    response = await axios.post(`${config.eastCoastDataApi()}VehicleElk/GetVehicleInTimeIntervalPerHour`, condition)

  } catch (err) {
    console.error('iisi postVehicleInTimeIntervalPerHour: ', err)
    return {}
  }

  Utils.setApiResponsSuccess(response)
  return response
}


export async function putLicensePlate(condition = {}) { 
  let response = {}

  if(Utils.isEmptyObject(condition) || Utils.isEmptyObject(condition.eventId) || Utils.isEmptyObject(condition.license) ) {
    console.log('iisi updateLicensePlate: condition error')
    return {}   
  }

  try {
    response = await axios.put(`${config.eastCoastDataApi()}VehicleElk/updateLicensePlate?eventId=${condition.eventId}&license=${condition.license}`)

  } catch (err) {
    console.error('iisi updateLicensePlate: ', err)
    return {}
  }

  Utils.setApiResponsSuccess(response)
  return response
}

export async function getSerialNumber(condition = {}){
  let response = {}
  
  if(Utils.isEmptyObject(condition) || Utils.isEmptyObject(condition.year) || Utils.isEmptyObject(condition.month) ) {
    console.log('iisi getSerialNumber: condition error')
    return {}   
  }

  
  try {
    response = await axios.get(`${config.eastCoastDataApi()}VehicleElk/GetSerialNumber?year=${condition.year}&month=${condition.month}`)

  } catch (err) {
    console.error('iisi getSerialNumber: ', err)
    return {}
  }
  
  Utils.setApiResponsSuccess(response)
  return response

}

export async function addSerialNumber(condition = {}){
  let response = {}
  
  if(Utils.isEmptyObject(condition)) {
    console.log('iisi addSerialNumber: condition error')
    return {}   
  }

  
  try {
    response = await axios.post(`${config.eastCoastDataApi()}VehicleElk/AddSerialNumber`,condition)

  } catch (err) {
    console.error('iisi addSerialNumber: ', err)
    return {}
  }

  
  Utils.setApiResponsSuccess(response)
  return response

}